<template>
  <div class="station-item">
    <div class="station inactive"
        :class="{ 'active-station': selected }"
        @click="$emit('highlight', station)">
          <div class="ping-distance" :class="{ 'active': selected }">
            <i class="el-icon-location"/>
          </div>
          <div>
            <p>{{ station.name }}</p>
            <span>{{ station.organization.name + distance }}</span>
          </div>
          <div class="status-block" v-if="!noStatus && inactive || maintain || down">
            <p class="active" :class="state">{{ statType }}</p>
            <span class="active" :class="state"></span>
          </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StationItem',
  props: {
    station: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      required: true
    },
    noStatus: Boolean
  },
  computed: {
    realDistance () {
      return (this.station.distance / 1000).toFixed(1)
    },
    distance () {
      if (this.$root.userLocation.enabled && !this.$root.userLocation.loading && this.realDistance < 1000) {
        let dist = this.realDistance

        if (dist < 1) {
          return ' - ' + dist * 1000 + ' m'
        }

        return ' - ' + dist + ' km'
      }

      return ''
    },
    state () {
      switch (this.station.statusType) {
        case 0:
          if (!this.station.member && !this.station.public) {
            return ['inactive']
          }
          return ['active']
        case 1:
          return ['maintenance']
        case 2:
          return ['inactive']
      }

      return []
    },
    statType () {
      if(this.inactive) {
        return 'Members only'
      } else if (this.down) {
        return 'Closed'
      } else if (this.maintain) {
        return 'Maintenance'
      } else {
        return ''
      }
    },
    maintain () {
      return this.station.statusType === 1
    },
    inactive () {
      return !this.station.member && !this.station.public
    },
    down () {
      return this.station.statusType === 2
    }
  }
}
</script>

<style lang="scss" scoped>

.ping-distance {
  width: auto;
  margin-right: 15px;
  display: flex;
  align-items: center;
  span {
    margin-top: 3px;
  }


  &.active {
    color: $main !important;
  }
}

.status-message {
  font-size: 12px;
  padding: 0px 10px 15px 36px;
  color: #F56C6C;
  box-sizing: border-box;
}

.station {
    width: 100%;
    display: flex;
    flex-direction: row !important;
    align-items: center;
    padding: 15px 20px;
    cursor: pointer;
    color: #606266;
    transition: color .1s linear;

    &:hover {
      color: $main;
    }

    .status-block {
      display: flex;
      align-items: center;
      flex-direction: row;
      margin-left: auto;
      padding-right: 16px;

      p {
        font-size: 10px;
        margin: 0;

        &.inactive {
          color: #F56C6C;
        }
        &.maintenance {
          color: #E6A23C;
        }
      }

      span {
        display: block;
        margin-left: 10px;
        margin-top: 2.8px;
        width: 8px;
        height: 8px;
        border-radius: 15px;

        &.active {
          background-color: #67C23A;
        }

        &.inactive {
          background-color: #F56C6C;
        }

        &.maintenance {
          background-color: #E6A23C;
        }
      }
    }


    i {
      font-size: 18px;
      padding-right: 0px;
    }

    div {
      display: flex;
      flex-direction: column;
      p {
        font-size: 14px;
        margin: 0px;
      }

      span {
        font-size: 10px;
        color: gray;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/stations/Station.vue